import { SAMPLING } from "../config";
import { metrics } from "../metrics";
import type { EnrichedEvent } from "../types";
import type { Provider } from "./types";

type MetricName = "LCP" | "INP" | "CLS" | "FCP" | "TTFB";

export class VitalsProvider implements Provider {
  readonly name = "vitals";
  readonly categories = ["essential"] as const;
  private loaded = false;
  private emit: ((name: "web_vital_measured", payload: Record<string, unknown>) => void) | null = null;

  setEmitter(fn: (name: "web_vital_measured", payload: Record<string, unknown>) => void): void {
    this.emit = fn;
  }

  async load(): Promise<void> {
    if (this.loaded) return;
    const t0 = performance.now();
    try {
      const wv = await import("web-vitals");
      const handler = (m: { name: MetricName; value: number; rating: "good" | "needs-improvement" | "poor" }) => {
        if (Math.random() > SAMPLING.vitals_sample_rate) return;
        if (!this.emit) return;
        try {
          this.emit("web_vital_measured", {
            metric: m.name,
            value: Math.round(m.value * 1000) / 1000,
            rating: m.rating,
            route: typeof window !== "undefined" ? window.location.pathname : "",
          });
        } catch {
          metrics.providerFailure("vitals");
        }
      };
      wv.onLCP(handler);
      wv.onINP(handler);
      wv.onCLS(handler);
      wv.onFCP(handler);
      wv.onTTFB(handler);
      this.loaded = true;
      metrics.providerLoadMs("vitals", Math.round(performance.now() - t0));
    } catch (err) {
      metrics.providerFailure("vitals");
      this.loaded = true;
      // eslint-disable-next-line no-console
      console.warn("[analytics] web-vitals load failed:", err);
    }
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  track(_event: EnrichedEvent): void {
    void _event;
  }
}
